module.exports = __webpack_public_path__ + "static/media/work-img6.2ec03805.jpg";